import clsx from "clsx";
import { Dropdown } from "react-bootstrap";

import { Icon, RenderWhen } from "../../../../../../components";

import { LayoutInfo } from "../../../layout-editor/@types";
import styles from "./layout-action.module.scss";

type Props = {
  title: string;
  layouts: Array<LayoutInfo>;
  selected?: number;
  onClick: (id: number) => void;
};

const MenuSection = ({ title, layouts, selected, onClick }: Props) => (
  <div className={styles.menu_section}>
    <Dropdown.Header className={styles.section_header}>
      {title}:
    </Dropdown.Header>
    <RenderWhen
      condition={Boolean(layouts.length)}
      fallback={<span className={styles.empty}>No Layouts Created</span>}
    >
      {layouts?.map(item => (
        <Dropdown.Item
          key={item.id}
          className={clsx(
            styles.section_item,
            selected === item.id && styles.active
          )}
          onClick={() => onClick(item.id)}
        >
          <RenderWhen condition={selected === item.id}>
            <Icon name="checkmark" />
          </RenderWhen>
          <span title={item.name}>{item.name}</span>
        </Dropdown.Item>
      ))}
    </RenderWhen>
  </div>
);

export default MenuSection;
